import PaymentClientService from "entities/payment-client-service";
import PaymentHeader, { PaymentHeaderTypes } from "entities/payment-header";
import { PaymentType } from "shared/utils/payment";
import PaymentMethods, { PaymentMethod } from "widgets/shared/payment-methods";
import PaymentWarranty from "widgets/payment-warranty";
import { PaymentActions } from "../../../../shared/utils/payment-methods";
import React from "react";
import { OrderType, usePaymentContext } from "../../providers/PaymentProvider";

interface PaymentTypeProps {
  paymentTypeList: PaymentType[];
  paymentAction: PaymentActions | null;
  setPaymentAction: React.Dispatch<React.SetStateAction<PaymentActions | null>>;
  setBank: React.Dispatch<React.SetStateAction<string>>;
  setPaymentMethod: React.Dispatch<React.SetStateAction<string>>;
}

export default function AllPayments({
  paymentTypeList,
  paymentAction,
  setPaymentAction,
  setBank,
  setPaymentMethod,
}: PaymentTypeProps) {
  const { orderType, doorOrder } = usePaymentContext();

  return (
    <div
      className={`gg-col-span-12 gg-mb-16 sm:gg-col-span-11 lg:gg-col-span-9 xl:gg-col-span-6 xl:gg-mb-0 xl:gg-pr-12`}
    >
      <PaymentHeader
        type={PaymentHeaderTypes.ALL_PAYMENTS}
        className="gg-mb-10"
      />
      {orderType !== OrderType.STANDARD_PRODUCT && (
        <PaymentWarranty hideSelection={doorOrder?.shoppingCart?.sampleSale} />
      )}
      <PaymentMethods
        method={PaymentMethod.DEFERRED_PAYMENT}
        types={paymentTypeList}
        paymentAction={paymentAction}
        setPaymentAction={setPaymentAction}
        orderType={orderType}
        isSampleSale={
          orderType === OrderType.DOOR && doorOrder?.shoppingCart?.sampleSale
        }
      />
      <PaymentClientService />
    </div>
  );
}
